
import { supabase } from "@/integrations/supabase/client";
import { UserRole } from "@/lib/types";

export async function hasRole(userId: string, role: UserRole): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .rpc('has_role', {
        user_id: userId,
        role: role
      });
      
    if (error) {
      console.error('Error checking user role:', error);
      return false;
    }
    
    return data || false;
  } catch (error) {
    console.error('Exception checking user role:', error);
    return false;
  }
}
